import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { MapRainforestMarker } from "types/map";
import MapMarkerRainforestButton from "./MapMarkerRainforestButton";

type Props = {
  map: google.maps.Map | null;
  marker: MapRainforestMarker;
  onMarkerSelect: (marker: MapRainforestMarker | null) => void;
  isSelected: boolean;
  color?: string;
};

const MapMarkerRainforest = ({
  map,
  marker,
  onMarkerSelect,
  isSelected,
  color,
}: Props) => {
  const markerRef = useRef<google.maps.marker.AdvancedMarkerElement | null>(
    null
  );
  const [size, setSize] = useState<"small" | "medium" | "large">("medium");

  // Create the container element once
  const [markerContainer] = useState(() => {
    const div = document.createElement("div");
    return div;
  });

  useEffect(() => {
    if (!map) return;

    const updateSize = () => {
      const zoom = map.getZoom();
      if (zoom === undefined) return;

      if (zoom < 4) {
        setSize("small");
      } else if (zoom < 6) {
        setSize("medium");
      } else {
        setSize("large");
      }
    };

    // Initial size set
    updateSize();

    const listener = map.addListener("zoom_changed", updateSize);

    return () => {
      google.maps.event.removeListener(listener);
    };
  }, [map]);

  useEffect(() => {
    if (!map) return;

    if (!markerRef.current) {
      markerRef.current = new google.maps.marker.AdvancedMarkerElement({
        map,
        position: {
          lat: marker.lat,
          lng: marker.lng,
        },
        content: markerContainer,
      });
    }

    return () => {
      if (markerRef.current) {
        markerRef.current.map = null;
        markerRef.current = null;
      }
    };
  }, [map, marker, markerContainer]);

  return createPortal(
    <MapMarkerRainforestButton
      marker={marker}
      onMarkerSelect={onMarkerSelect}
      isSelected={isSelected}
      color={color}
      size={size}
    />,
    markerContainer
  );
};

export default MapMarkerRainforest;
